import { actionChannel, call, take, takeEvery } from 'typed-redux-saga';
import {
  addDiscountCodeRequested,
  addDiscountCodeRequestedType,
  addDiscountCodeToCurrentCartsRequestedType,
  addEmployeeDiscountCodeToCurrentCartsRequestedType,
  addGiftCardToCartRequested,
  addGiftCardToCartRequestedType,
  addProductsToCurrentCartRequested,
  addProductsToCurrentCartRequestedType,
  addToCurrentCartRequested,
  addToCurrentCartRequestedType,
  changeCurrentCartBirthDateRequested,
  changeCurrentCartBirthDateRequestedType,
  changeCurrentCartContactRequested,
  changeCurrentCartContactRequestedType,
  changeCurrentCartDeliveryAddressRequested,
  changeCurrentCartDeliveryAddressRequestedType,
  changeCurrentCartDeliveryModeRequested,
  changeCurrentCartDeliveryModeRequestedType,
  changeCurrentCartEmailRequested,
  changeCurrentCartEmailRequestedType,
  changeCurrentCartPaymentAddressRequested,
  changeCurrentCartPaymentAddressRequestedType,
  changeCurrentCartPaymentModeRequested,
  changeCurrentCartPaymentModeRequestedType,
  changeCurrentCartSelectedStoreRequested,
  changeCurrentCartSelectedStoreRequestedType,
  changeCurrentCartTypeRequested,
  changeCurrentCartTypeRequestedType,
  deleteCurrentCartEntryRequested,
  deleteCurrentCartEntryRequestedType,
  deleteCurrentCartRequested,
  deleteCurrentCartRequestedType,
  placeCurrentCartsRequested,
  placeCurrentCartsRequestedType,
  registerCustomerAndChangeAddressesAndSignInRequestedType,
  removeAllDiscountCodesFromCartsRequestedType,
  removeDiscountCodeFromCartsRequestedType,
  removeDiscountCodeRequested,
  removeDiscountCodeRequestedType,
  removeGiftCardFromCartRequested,
  removeGiftCardFromCartRequestedType,
  updateCurrentCartEntryQuantityRequested,
  updateCurrentCartEntryQuantityRequestedType
} from '../../carts/cartsSlice';
import addDiscountCodeToCurrentCartSaga from '@spa/lib/store/sagas/cart-and-place-order/addDiscountCodeToCurrentCartSaga';
import addDiscountCodeToCurrentCartsSaga from '@spa/lib/store/sagas/cart-and-place-order/addDiscountCodeToCurrentCartsSaga';
import { addEmployeeDiscountCodesToCurrentCartsSaga } from '@spa/lib/store/sagas/cart-and-place-order/addEmployeeDiscountCodesToCurrentCartsSaga';
import addGiftCardToCurrentCartSaga from '@spa/lib/store/sagas/cart-and-place-order/addGiftCardToCurrentCartSaga';
import addProductsToCurrentCartSaga from './addProductsToCurrentCartSaga';
import addToCurrentCartSaga from './addToCurrentCartSaga';
import changeCurrentCartBirthDateSaga from './changeCurrentCartBirthDateSaga';
import changeCurrentCartContactSaga from './changeCurrentCartContactSaga';
import changeCurrentCartDeliveryAddressSaga from './changeCurrentCartDeliveryAddressSaga';
import changeCurrentCartDeliveryModeSaga from './changeCurrentCartDeliveryModeSaga';
import changeCurrentCartEmailSaga from './changeCurrentCartEmailSaga';
import changeCurrentCartPaymentAddressSaga from './changeCurrentCartPaymentAddressSaga';
import changeCurrentCartPaymentModeSaga from './changeCurrentCartPaymentModeSaga';
import changeCurrentCartSelectedStoreSaga from './changeCurrentCartSelectedStoreSaga';
import changeCurrentCartTypeSaga from './changeCurrentCartTypeSaga';
import deleteCurrentCartEntrySaga from './deleteCurrentCartEntrySaga';
import deleteCurrentCartSaga from './deleteCurrentCartSaga';
import { fork } from 'typed-redux-saga';
import logger from '@spa/lib/logger';
import placeCurrentCartsSaga from '@spa/lib/store/sagas/cart-and-place-order/placeCurrentCartsSaga';
import registerCustomerAndChangeAddressesAndSignInSaga from './registerCustomerAndChangeAddressesAndSignInSaga';
import removeAllDiscountCodesFromCartsSaga from '@spa/lib/store/sagas/cart-and-place-order/removeAllDiscountCodesFromCartsSaga';
import removeDiscountCodeFromCartSaga from '@spa/lib/store/sagas/cart-and-place-order/removeDiscountCodeFromCartSaga';
import removeDiscountCodeFromCartsSaga from '@spa/lib/store/sagas/cart-and-place-order/removeDiscountCodeFromCartsSaga';
import removeGiftCardFromCartSaga from '@spa/lib/store/sagas/cart-and-place-order/removeGiftCardFromCartSaga';
import updateCurrentCartEntryQuantitySaga from './updateCurrentCartEntryQuantitySaga';
import watchAndNotifyCurrentCartChanges from '@spa/lib/store/sagas/cart-and-place-order/watchAndNotifyCurrentCartChanges';

function* watchCurrentCartActionsSaga(): Generator {
  yield* fork(watchAndNotifyCurrentCartChanges);
  yield* takeEvery(
    registerCustomerAndChangeAddressesAndSignInRequestedType,
    registerCustomerAndChangeAddressesAndSignInSaga
  );
  yield* takeEvery(addDiscountCodeToCurrentCartsRequestedType, addDiscountCodeToCurrentCartsSaga);
  yield* takeEvery(
    addEmployeeDiscountCodeToCurrentCartsRequestedType,
    addEmployeeDiscountCodesToCurrentCartsSaga
  );
  yield* takeEvery(removeDiscountCodeFromCartsRequestedType, removeDiscountCodeFromCartsSaga);
  yield* takeEvery(
    removeAllDiscountCodesFromCartsRequestedType,
    removeAllDiscountCodesFromCartsSaga
  );

  const requestChan = yield* actionChannel([
    addDiscountCodeRequestedType,
    addToCurrentCartRequestedType,
    addProductsToCurrentCartRequestedType,
    changeCurrentCartEmailRequestedType,
    changeCurrentCartBirthDateRequestedType,
    changeCurrentCartContactRequestedType,
    changeCurrentCartDeliveryAddressRequestedType,
    changeCurrentCartSelectedStoreRequestedType,
    changeCurrentCartPaymentAddressRequestedType,
    changeCurrentCartDeliveryModeRequestedType,
    changeCurrentCartTypeRequestedType,
    changeCurrentCartPaymentModeRequestedType,
    placeCurrentCartsRequestedType,
    removeDiscountCodeRequestedType,
    addGiftCardToCartRequestedType,
    removeGiftCardFromCartRequestedType,
    updateCurrentCartEntryQuantityRequestedType,
    deleteCurrentCartEntryRequestedType,
    deleteCurrentCartRequestedType
  ]);
  while (true) {
    const action = yield* take(requestChan);
    if (addDiscountCodeRequested.match(action)) {
      yield* call(addDiscountCodeToCurrentCartSaga, action);
    } else if (addToCurrentCartRequested.match(action)) {
      yield* call(addToCurrentCartSaga, action);
    } else if (addProductsToCurrentCartRequested.match(action)) {
      yield* call(addProductsToCurrentCartSaga, action);
    } else if (changeCurrentCartEmailRequested.match(action)) {
      yield* call(changeCurrentCartEmailSaga, action);
    } else if (changeCurrentCartBirthDateRequested.match(action)) {
      yield* call(changeCurrentCartBirthDateSaga, action);
    } else if (changeCurrentCartContactRequested.match(action)) {
      yield* call(changeCurrentCartContactSaga, action);
    } else if (changeCurrentCartDeliveryAddressRequested.match(action)) {
      yield* call(changeCurrentCartDeliveryAddressSaga, action);
    } else if (changeCurrentCartSelectedStoreRequested.match(action)) {
      yield* call(changeCurrentCartSelectedStoreSaga, action);
    } else if (changeCurrentCartPaymentAddressRequested.match(action)) {
      yield* call(changeCurrentCartPaymentAddressSaga, action);
    } else if (changeCurrentCartDeliveryModeRequested.match(action)) {
      yield* call(changeCurrentCartDeliveryModeSaga, action);
    } else if (changeCurrentCartTypeRequested.match(action)) {
      yield* call(changeCurrentCartTypeSaga, action);
    } else if (changeCurrentCartPaymentModeRequested.match(action)) {
      yield* call(changeCurrentCartPaymentModeSaga, action);
    } else if (placeCurrentCartsRequested.match(action)) {
      yield* call(placeCurrentCartsSaga, action);
    } else if (updateCurrentCartEntryQuantityRequested.match(action)) {
      yield* call(updateCurrentCartEntryQuantitySaga, action);
    } else if (deleteCurrentCartEntryRequested.match(action)) {
      yield* call(deleteCurrentCartEntrySaga, action);
    } else if (deleteCurrentCartRequested.match(action)) {
      yield* call(deleteCurrentCartSaga, action);
    } else if (removeDiscountCodeRequested.match(action)) {
      yield* call(removeDiscountCodeFromCartSaga, action);
    } else if (addGiftCardToCartRequested.match(action)) {
      yield* call(addGiftCardToCurrentCartSaga, action);
    } else if (removeGiftCardFromCartRequested.match(action)) {
      yield* call(removeGiftCardFromCartSaga, action);
    } else {
      logger.error('Could not match action [Type: ' + action.type + ']');
    }
  }
}

export default watchCurrentCartActionsSaga;
